import { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Pencil, X } from '@phosphor-icons/react'
import get from 'lodash/get'

import { useClickOutside } from '../../../helpers/hooks/useClickOutside'
import TextField from '../../FormLegacy/FormFieldsV2/TextField'

const SelectedRoomHead = ({
  rooms,
  errors,
  selectedRoom,
  selectedRoomIndex,
  selectedRoomId,
  onEditRoom = () => {},
}) => {
  const [editNameVisible, setEditNameVisible] = useState(false)
  const editNameRef = useRef(null)

  useClickOutside(editNameRef, () => {
    if (
      !get(errors, `rooms[${rooms.findIndex((room) => room.id === editNameRef.current.id)}].name`)
    ) {
      setEditNameVisible(false)
    }
  })

  return (
    <div className="head">
      {editNameVisible ? (
        <div className="edit-name" ref={editNameRef} id={selectedRoom.id}>
          <TextField
            additionalClass="editable-input title"
            name="name"
            onChange={(e) => onEditRoom(selectedRoomId, 'name', e.target.value)}
            value={selectedRoom.name}
            onBlur={() => {
              if (!get(errors, `rooms[${selectedRoomIndex}].name`)) {
                setEditNameVisible(false)
              }
            }}
            isError={!!get(errors, `rooms[${selectedRoomIndex}].name`)}
            errorLabel={get(errors, `rooms[${selectedRoomIndex}].name`)}
          />
          <X className="cross" onClick={() => onEditRoom(selectedRoomId, 'name', '')} />
        </div>
      ) : (
        <div className="edit-name">
          <span className="inspections-title">{selectedRoom.name}</span>
          <Pencil onClick={() => setEditNameVisible(true)} />
        </div>
      )}
    </div>
  )
}

SelectedRoomHead.propTypes = {
  rooms: PropTypes.array,
  errors: PropTypes.object,
  selectedRoom: PropTypes.object,
  selectedRoomIndex: PropTypes.number,
  selectedRoomId: PropTypes.string,
  onEditRoom: PropTypes.func,
}

export default SelectedRoomHead
